import { Icon } from '@/src/components/ui';
import { Badge } from '@workspace/ui/components/badge';
import { cn } from '@workspace/ui/lib/utils';
import React from 'react';
import { useProfileUIStore } from '../../profile/store';
import { SafeIcon } from '@/src/components/ui/SafeIcon';

type Props = {
  tags: string[];
  className?: string;
};

export const TagsList = ({ tags, className }: Props) => {
  const isMobileView = useProfileUIStore((state) => state.isMobileView);

  return (
    <div
      className={cn(
        'flex gap-2 flex-wrap md:mt-4 md:mb-7 mt-3 mb-4 text-black',
        className,
        {
          'md:flex-nowrap': !isMobileView,
        }
      )}
    >
      {tags.map((tag) => (
        <Badge
          key={tag}
          variant="secondary"
          className="bg-background-gray md:text-sm text-xs md:py-1 md:px-2 p-1 flex gap-1 transition-colors text-black items-center border-1 md:h-[30px] rounded-[6px] border-[#1E1E1E0D]"
        >
          <SafeIcon
            name={tag.toLowerCase()}
            fallback="logo-heart-3"
            className="size-3.5"
          />
          <span>{tag}</span>
        </Badge>
      ))}
    </div>
  );
};
